module.exports = {
      id: "google-plain-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "svg-sprite-c16dead317bf40daa0a857495c90b974.svg#google-plain",
      toString: function () {
        return this.url;
      }
    }